import { render } from "./EditIconsBlock.vue?vue&type=template&id=5fc93395&scoped=true"
import script from "./EditIconsBlock.vue?vue&type=script&lang=js"
export * from "./EditIconsBlock.vue?vue&type=script&lang=js"

import "./EditIconsBlock.vue?vue&type=style&index=0&id=5fc93395&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fc93395"]])

export default __exports__